import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { DrawSetting } from '@agissc/ktag-map';
import DrawControlsLabel from './DrawControlsLabel';
import { DRAW_COLORS } from './constants';
import useAppState from '../../../AppStore';

const ColorSelection = () => {
  const { t } = useTranslation('agisviewer');

  const selectedFeatureId = useAppState((state) => state.selectedFeatureId);
  const drawFeatures = useAppState((state) => state.drawFeatures);
  const feature = drawFeatures.find((f) => f.id === selectedFeatureId)!;

  const selectedColor = feature.properties.settings[DrawSetting.Color];
  const editDrawFeature = useAppState((state) => state.editDrawFeature);
  const setDrawSetting = useAppState((state) => state.setDrawSetting);

  const setSelectedColor = (color: string) => {
    editDrawFeature(selectedFeatureId!, {
      properties: {
        settings: { [DrawSetting.Color]: color },
      },
    });
    setDrawSetting(DrawSetting.Color, color);
  };

  return (
    <>
      <DrawControlsLabel>{t('draw_control_color')}</DrawControlsLabel>
      <div className="draw-settings__colors">
        {DRAW_COLORS.map((color) => (
          <button
            type="button"
            key={color}
            aria-label={color}
            onClick={() => setSelectedColor(color)}
            className={classNames('draw-settings__color', {
              'draw-settings__color--active': color === selectedColor,
            })}
            style={{ backgroundColor: color }}
          />
        ))}
      </div>
    </>
  );
};

export default ColorSelection;
